export default "__VITE_ASSET__BE4$X_WO__"